export default function getCloudimageUrl(url, params = {}) {
    const cloudimageToken = process.env.NODE_ENV === 'production' ? 'amudynecep' : null;

    if (!cloudimageToken || !url) return url;

    let cloudimageUrl = new URL(`https://${cloudimageToken}.cloudimg.io/v7/${url}`);

    Object.entries(params).forEach(([key, value]) => {
        cloudimageUrl.searchParams.append(key, value === true ? 1 : value);
    });

    return cloudimageUrl.toString();
}
